export const MAIN_WINDOW_ID = 'mainWindow';
export const HEADER_COMPONENT_ID = 'suiteHeader';
